/* 
 * Layout 
 */
window.Lib = {
	Helpers: require('./lib/helpers.js'),
    Form: require('./lib/form.js')
};

require('../styles/shared.scss');


// WEBPACK FOOTER //
// ./client/src/js/shared.js